import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "c-footer__container" }
const _hoisted_2 = { class: "c-footer__menu" }
const _hoisted_3 = { class: "c-footer__menu-title" }
const _hoisted_4 = {
  key: 0,
  class: "c-footer__menu-items"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 0,
  class: "c-footer__menu-column"
}
const _hoisted_7 = {
  key: 0,
  class: "c-footer__menu-title"
}
const _hoisted_8 = { class: "c-footer__contact-grid" }
const _hoisted_9 = { class: "c-footer__contact-label" }
const _hoisted_10 = {
  key: 0,
  class: "c-footer__contact-list"
}
const _hoisted_11 = {
  key: 0,
  class: "c-footer__contact-region"
}
const _hoisted_12 = {
  key: 2,
  class: "c-footer__contact-link"
}
const _hoisted_13 = {
  key: 2,
  class: "c-footer__extra"
}
const _hoisted_14 = {
  key: 0,
  class: "c-footer__social-wrapper"
}
const _hoisted_15 = {
  key: 3,
  class: "c-footer__bottom"
}
const _hoisted_16 = {
  key: 0,
  class: "c-footer__copyright"
}
const _hoisted_17 = {
  key: 1,
  class: "c-footer__bottom-links"
}
const _hoisted_18 = { class: "c-footer-newsletter-modal__panel" }
const _hoisted_19 = { class: "c-footer-newsletter-modal__captcha" }
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 0,
  class: "c-footer-newsletter-modal__captcha-error"
}

import { computed, ref } from 'vue';
import { Text } from '@sitecore-jss/sitecore-jss-vue';
import Modal from '@/elements/Modal.vue';
import SiteImage from '@/elements/SiteImage.vue';
import { settingValue } from '@/utils/site-utils';
import SiteLink from '@/elements/SiteLink.vue';
import type { FooterProps } from '@/types/components/Footer';

const newsletterCaptchaCode = '8290';


export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  props: {
    fields: {},
    rendering: {}
  },
  setup(__props: any) {

const props = __props;
const newsletterModalRef = ref<InstanceType<typeof Modal> | null>(null);
const newsletterCaptchaValue = ref('');
const newsletterCaptchaError = ref('');
const footerStyle = computed(() => ({
  backgroundColor: settingValue(props.fields?.backColor),
  color: settingValue(props.fields?.foreColor),
}));
const contactMenuItem = computed(() =>
  props.fields?.menuList?.find((item) => !item.fields?.childList?.length)
);
const menuItems = computed(() =>
  (props.fields?.menuList ?? []).filter((item) => item.fields?.childList?.length)
);
const opensInNewWindow = (link: any) => link?.value?.target === '_blank';
const getLinkHref = (link: any) => link?.value?.href || '#';
const hasLogoSvg = computed(() => Boolean(props.fields?.logo?.value?.svgCode));

const newsletterCaptchaImage = computed(() => {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="106" height="56" viewBox="0 0 106 56">
    <rect width="106" height="56" rx="7" fill="#f8f8f8"/>
    <path d="M-6 38 C16 8, 42 52, 66 18 S98 32, 112 8" fill="none" stroke="#58a843" stroke-width="1.2" opacity=".8"/>
    <path d="M0 18 L106 40" stroke="#7fb85e" stroke-width="1" opacity=".7"/>
    <path d="M12 50 L98 6" stroke="#884fc7" stroke-width="1" opacity=".55"/>
    <text x="53" y="38" text-anchor="middle" fill="#7c8e34" font-size="31" font-family="Georgia, serif" font-style="italic" font-weight="700" transform="rotate(-12 53 30)">${newsletterCaptchaCode}</text>
    <g fill="#58a843" opacity=".75">
      <circle cx="14" cy="15" r="1"/><circle cx="31" cy="42" r="1"/><circle cx="49" cy="12" r="1"/>
      <circle cx="70" cy="45" r="1"/><circle cx="88" cy="17" r="1"/>
    </g>
  </svg>`;

  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
});

const openNewsletterModal = () => {
  newsletterCaptchaValue.value = '';
  newsletterCaptchaError.value = '';
  newsletterModalRef.value?.open();
};

const closeNewsletterModal = () => {
  newsletterCaptchaValue.value = '';
  newsletterCaptchaError.value = '';
  newsletterModalRef.value?.close();
};

const onNewsletterCaptchaInput = () => {
  newsletterCaptchaError.value = '';
};

const confirmNewsletterCaptcha = () => {
  if (newsletterCaptchaValue.value.trim() !== newsletterCaptchaCode) {
    newsletterCaptchaError.value = 'Please enter the security code shown on the right.';
    return;
  }

  closeNewsletterModal();
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_icon = _resolveComponent("icon")!
  const _component_ContentGrid = _resolveComponent("ContentGrid")!

  return (__props.fields)
    ? (_openBlock(), _createElementBlock("footer", {
        key: 0,
        class: "c-footer",
        style: _normalizeStyle(footerStyle.value)
      }, [
        _createVNode(_component_ContentGrid, {
          "desktop-default-grid": [1, 22],
          "mobile-default-grid": [1, 14]
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (hasLogoSvg.value)
                ? (_openBlock(), _createBlock(_component_Icon, {
                    key: 0,
                    class: "c-footer__logo",
                    field: __props.fields.logo
                  }, null, 8, ["field"]))
                : (__props.fields.logo)
                  ? (_openBlock(), _createBlock(SiteImage, {
                      key: 1,
                      class: "c-footer__logo",
                      field: __props.fields.logo,
                      loading: "eager"
                    }, null, 8, ["field"]))
                  : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "c-footer__menu-column",
                    key: item.id
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_unref(Text), {
                        field: item.fields.title
                      }, null, 8, ["field"])
                    ]),
                    (item.fields?.childList?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.fields.childList, (child) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: child.id
                            }, [
                              (opensInNewWindow(child.fields.link))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: getLinkHref(child.fields.link),
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    class: "c-footer__menu-link"
                                  }, [
                                    _createVNode(_unref(Text), {
                                      field: child.fields.text
                                    }, null, 8, ["field"])
                                  ], 8, _hoisted_5))
                                : (_openBlock(), _createBlock(SiteLink, {
                                    key: 1,
                                    link: child.fields.link,
                                    class: "c-footer__menu-link"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Text), {
                                        field: child.fields.text
                                      }, null, 8, ["field"])
                                    ]),
                                    _: 2
                                  }, 1032, ["link"]))
                            ], 64))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                (__props.fields?.contactList?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (contactMenuItem.value?.fields?.title)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(_unref(Text), {
                              field: contactMenuItem.value.fields.title
                            }, null, 8, ["field"])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.fields.contactList, (contact) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "c-footer__contact-column",
                            key: contact.id
                          }, [
                            _createElementVNode("div", _hoisted_9, [
                              _createVNode(_unref(Text), {
                                field: contact.fields.title
                              }, null, 8, ["field"])
                            ]),
                            (contact.fields?.contactItems?.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contact.fields.contactItems, (contactItem) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: contactItem.id,
                                      class: "c-footer__contact-row"
                                    }, [
                                      (contactItem.fields?.region?.value)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(contactItem.fields.region.value), 1))
                                        : _createCommentVNode("", true),
                                      (contactItem.fields?.link)
                                        ? (_openBlock(), _createBlock(SiteLink, {
                                            key: 1,
                                            link: contactItem.fields.link,
                                            class: "c-footer__contact-link"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(Text), {
                                                field: contactItem.fields.value
                                              }, null, 8, ["field"])
                                            ]),
                                            _: 2
                                          }, 1032, ["link"]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                            _createVNode(_unref(Text), {
                                              field: contactItem.fields.value
                                            }, null, 8, ["field"])
                                          ]))
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (__props.fields?.newsletterTitle?.value || __props.fields?.socialMediaList?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (__props.fields?.socialMediaList?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.fields.socialMediaList, (social) => {
                            return (_openBlock(), _createBlock(SiteLink, {
                              key: social.id,
                              link: social.fields.link,
                              class: "c-footer__social-link",
                              "aria-label": social.fields.name?.value
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_icon, {
                                  field: social.fields.icon,
                                  class: "c-footer__social-icon"
                                }, null, 8, ["field"])
                              ]),
                              _: 2
                            }, 1032, ["link", "aria-label"]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (__props.fields?.copyright?.value || __props.fields?.bottomLinks?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (__props.fields?.copyright?.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createVNode(_unref(Text), {
                            field: __props.fields.copyright
                          }, null, 8, ["field"])
                        ]))
                      : _createCommentVNode("", true),
                    (__props.fields?.bottomLinks?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.fields.bottomLinks, (link) => {
                            return (_openBlock(), _createBlock(SiteLink, {
                              key: link.id,
                              link: link.fields.link,
                              class: "c-footer__bottom-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Text), {
                                  field: link.fields.text
                                }, null, 8, ["field"])
                              ]),
                              _: 2
                            }, 1032, ["link"]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(Modal, {
          ref_key: "newsletterModalRef",
          ref: newsletterModalRef,
          class: "c-footer-newsletter-modal",
          "content-class": "c-footer-newsletter-modal__modal",
          closable: false,
          sticky: false,
          "is-full": true
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                class: "c-footer-newsletter-modal__close",
                type: "button",
                "aria-label": "Close",
                onClick: closeNewsletterModal
              }, [
                _createVNode(_component_Icon, {
                  name: "close",
                  size: "small"
                })
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Email Security Verification", -1)),
              _cache[2] || (_cache[2] = _createElementVNode("p", { class: "c-footer-newsletter-modal__description" }, " To ensure subscription security, please enter the security code for verification. ", -1)),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", {
                  class: _normalizeClass([
              'c-footer-newsletter-modal__captcha-field',
              { 'has-error': Boolean(newsletterCaptchaError.value) },
            ])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newsletterCaptchaValue).value = $event)),
                    type: "text",
                    inputmode: "text",
                    autocomplete: "off",
                    autocapitalize: "none",
                    spellcheck: "false",
                    placeholder: "security code on the right",
                    "aria-label": "Security code",
                    onInput: onNewsletterCaptchaInput
                  }, null, 544), [
                    [_vModelText, newsletterCaptchaValue.value]
                  ])
                ], 2),
                _createElementVNode("img", {
                  class: "c-footer-newsletter-modal__captcha-image",
                  src: newsletterCaptchaImage.value,
                  alt: "Security code"
                }, null, 8, _hoisted_20),
                (newsletterCaptchaError.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(newsletterCaptchaError.value), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                class: "c-footer-newsletter-modal__submit",
                type: "button",
                onClick: confirmNewsletterCaptcha
              }, " Sure ")
            ])
          ]),
          _: 1
        }, 512)
      ], 4))
    : _createCommentVNode("", true)
}
}

})